import { render, staticRenderFns } from "./set_truck_owner_info.vue?vue&type=template&id=1e8b0544&scoped=true&"
import script from "./set_truck_owner_info.vue?vue&type=script&lang=js&"
export * from "./set_truck_owner_info.vue?vue&type=script&lang=js&"
import style0 from "./set_truck_owner_info.vue?vue&type=style&index=0&id=1e8b0544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b0544",
  null
  
)

export default component.exports